export enum CappingLevel {
  Off = 0,
  CampaignFixed = 1,
  ProfileFixed = 2,
  CampaignPercentage = 3,
  ProfilePercentage = 4,
  AudienceFixed = 5,
  AudiencePercentage = 6
}
